import { useCompanies, useUsers } from '@adsk/alloy-provider';

interface UserData {
  isLoading: boolean;
  name?: string;
  company?: string;
}

export default function useUserData(userId: string): UserData {
  const { data: users, loading } = useUsers();
  const { data: companies } = useCompanies();

  const user = users.find((user) => user.autodeskId === userId);
  if (!user) {
    return {
      isLoading: loading,
    };
  }
  const company = companies.find((company) => company.id === user.companyId);

  return {
    name: user.name,
    company: company ? company.name : undefined,
    isLoading: false,
  };
}
